import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useAuth } from '../context/authContext'

const Navbar = () => {
    
    const state = useSelector(state => state.handleCart)
    const { logout, loading } = useAuth();
    const handleLogout = async () => {
        try {
          await logout();
        } catch (error) {
          console.error(error.message);
        }
      };
    
    if (loading) return <h1>Cargando</h1>

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 sticky-top">
            <div className="container">
                <NavLink className="navbar-brand fw-bold fs-4 px-2" to="/"> React TESJi Shop</NavLink>
                <button className="navbar-toggler mx-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav m-auto my-2 text-center">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/">Inicio </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/product">Productos</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/pruebas">Administrar </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/about">Acerca de</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/contact">Contacto</NavLink>
                        </li>
                        
                    </ul>
                    <div className="buttons text-center">
                        <NavLink to="/login" className="btn btn-outline-dark m-2"><i className="fa fa-sign-in-alt mr-1"></i> Acceder</NavLink>
                        <NavLink to="/register" className="btn btn-outline-dark m-2"><i className="fa fa-user-plus mr-1"></i> Registrarse</NavLink>                   
                        <NavLink to="/login" className="btn btn-outline-dark m-2"><i className="fa fa-user-plus mr-1" onClick={handleLogout}></i> Salir</NavLink>
                        <NavLink to="/cart" className="btn btn-outline-dark m-2"><i className="fa fa-cart-shopping mr-1"></i> Carrito ({state.length}) </NavLink>
                    </div>
                </div>


            </div>
        </nav>
    )
}

export default Navbar

/*
<li className="nav-item">
                            <NavLink className="nav-link" to="/createproduct">Vender productos</NavLink>
                        </li>

*/ 